var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import AllCaseList from "~/components/collection-manage/all-case/all-case-list.vue";
import BatchCase from "~/components/collection-manage/all-case/batch-case.vue";
import { State } from "vuex-class";
import { Watch } from "vue-property-decorator";
import { Layout } from "~/core/decorator";
//@Auth(105)
var AllCase = /** @class */ (function (_super) {
    __extends(AllCase, _super);
    function AllCase() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.principalId = "";
        _this.batchNumber = "";
        _this.currentComponent = "AllCaseList";
        _this.groupType = "";
        return _this;
    }
    AllCase.prototype.principalIdChange = function (val) {
        if (!val)
            return;
        this.principalId = val.params.principalId;
        this.currentComponent = "AllCaseList";
    };
    AllCase.prototype.created = function () { };
    AllCase.prototype.mounted = function () {
        this.principalId = this.$route.params["principalId"];
    };
    AllCase.prototype.onClickBatchNumber = function (currentCollection, groupType) {
        this.batchNumber = currentCollection.batchNumber;
        this.groupType = groupType;
        this.currentComponent = "BatchCase";
    };
    AllCase.prototype.onBackCollection = function () {
        this.currentComponent = "AllCaseList";
    };
    __decorate([
        State
    ], AllCase.prototype, "userData", void 0);
    __decorate([
        State
    ], AllCase.prototype, "principalList", void 0);
    __decorate([
        Watch("$route", { immediate: true })
    ], AllCase.prototype, "principalIdChange", null);
    AllCase = __decorate([
        Layout("workspace"),
        Component({
            components: {
                BatchCase: BatchCase,
                AllCaseList: AllCaseList
            }
        })
    ], AllCase);
    return AllCase;
}(Vue));
export default AllCase;
